import useTranslation from 'next-translate/useTranslation';
import useApplicationData from 'src/hooks/useApplicationData';
import useContextMenu from 'src/hooks/useContextMenu';
import useKeyboardInteractions from 'src/hooks/useKeyboardInteractions';
import useKeyboardShortcuts from 'src/hooks/useKeyboardShortcuts';
import useUI from 'src/hooks/useUI';
import { KEYBOARD_SHORTCUTS, MEDIA_TYPE } from 'src/interfaces/enums';
import ContextMenu from 'src/themes/cosmos/components/ContextMenu';
import ContextMenuItem from 'src/themes/cosmos/components/ContextMenuItem';
import { ReloadIcon, StatsIcon } from 'src/themes/cosmos/icons';
import { reloadPage } from 'src/utils/browserUtils';

const PlayerContextMenu = () => {
  const { t } = useTranslation('common');
  const { isContextMenuVisible, contextMenuPosition, hideContextMenu } = useContextMenu();
  const { registerItem } = useKeyboardInteractions();
  const { setShowStats } = useUI();
  const { mediaType } = useApplicationData();

  useKeyboardShortcuts({
    [KEYBOARD_SHORTCUTS.CLOSE_FLOATING_OVERLAY]: hideContextMenu,
  });

  const isAudio = mediaType === MEDIA_TYPE.audio;

  return (
    <ContextMenu visible={isContextMenuVisible} position={contextMenuPosition} onHide={hideContextMenu}>
      <ContextMenuItem
        {...registerItem({
          index: 0,
        })}
        data-testid='context-menu-media-data'
        icon={<StatsIcon />}
        text={isAudio ? t('context_menu.audio_data') : t('context_menu.video_data')}
        onClick={() => {
          hideContextMenu();
          setShowStats();
        }}
      />
      <ContextMenuItem
        {...registerItem({
          index: 1,
        })}
        icon={<ReloadIcon />}
        text={isAudio ? t('context_menu.reload_audio') : t('context_menu.reload_video')}
        onClick={reloadPage}
      />
    </ContextMenu>
  );
};

export default PlayerContextMenu;
